import { Translation } from '@ps/web-shared-components';

import Size10Icon from '../../../assets/icons/table-size/seat-10.svg';
import Size2Icon from '../../../assets/icons/table-size/seat-2.svg';
import Size3Icon from '../../../assets/icons/table-size/seat-3.svg';
import Size4Icon from '../../../assets/icons/table-size/seat-4.svg';
import Size5Icon from '../../../assets/icons/table-size/seat-5.svg';
import Size6Icon from '../../../assets/icons/table-size/seat-6.svg';
import Size7Icon from '../../../assets/icons/table-size/seat-7.svg';
import Size8Icon from '../../../assets/icons/table-size/seat-8.svg';
import Size9Icon from '../../../assets/icons/table-size/seat-9.svg';
import type { IconsLegendData } from '../IconGroupLegend';
import IconGroupLegend from '../IconGroupLegend';

import {
  TXTCLI_2_seat_table_XHeads_upX,
  TXTCLI_N0_seat_table,
  TXTCLI_Table_Size
} from './TableSizeIconLegend.messages.json';

const tableSeatsConfig: IconsLegendData[] = [
  {
    Icon: <Size10Icon />,
    Description: <Translation tagName="span" values={{ 0: 10 }} {...TXTCLI_N0_seat_table} />
  },
  {
    Icon: <Size9Icon />,
    Description: <Translation tagName="span" values={{ 0: 9 }} {...TXTCLI_N0_seat_table} />
  },
  {
    Icon: <Size8Icon />,
    Description: <Translation tagName="span" values={{ 0: 8 }} {...TXTCLI_N0_seat_table} />
  },
  {
    Icon: <Size7Icon />,
    Description: <Translation tagName="span" values={{ 0: 7 }} {...TXTCLI_N0_seat_table} />
  },
  {
    Icon: <Size6Icon />,
    Description: <Translation tagName="span" values={{ 0: 6 }} {...TXTCLI_N0_seat_table} />
  },
  {
    Icon: <Size5Icon />,
    Description: <Translation tagName="span" values={{ 0: 5 }} {...TXTCLI_N0_seat_table} />
  },
  {
    Icon: <Size4Icon />,
    Description: <Translation tagName="span" values={{ 0: 4 }} {...TXTCLI_N0_seat_table} />
  },
  {
    Icon: <Size3Icon />,
    Description: <Translation tagName="span" values={{ 0: 3 }} {...TXTCLI_N0_seat_table} />
  },
  {
    Icon: <Size2Icon />,
    Description: <Translation tagName="span" {...TXTCLI_2_seat_table_XHeads_upX} />
  }
];

const TableSizeIconLegend: React.FC = () => (
  <IconGroupLegend data={tableSeatsConfig} title={<Translation {...TXTCLI_Table_Size} />} />
);

export default TableSizeIconLegend;
